import { useQuery } from 'data-fetching-client';
import { fetchAllCategoriesQuery } from '../queries/categories.queries';
import { useMemo } from 'react';
//re-export to enable refetching
export { fetchAllCategoriesQuery } from '../queries/categories.queries';
export const useSkillCategories = (skip = false) => {
  const {
    data,
    loading,
    error
  } = useQuery(fetchAllCategoriesQuery, {
    skip
  });
  const categories = useMemo(() => data && Array.isArray(data.allCategories) ? data.allCategories : [], [data]);
  return {
    categories,
    loading,
    error
  };
};